import React from 'react';

import { Popconfirm, Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ButtonType } from 'antd/lib/button';

interface RemoveButtonProps {
  text?: string;
  onClick?: (any) => any;
  onConfirm?: (any) => any;
  confirmmessage?: string;
  onCancel?: (any) => any;
  type?: ButtonType;
  tooltip?: string;
}

const RemoveButton: React.FC<RemoveButtonProps> = ({
  text,
  confirmmessage = 'Confermare?',
  onConfirm,
  onCancel,
  onClick,
  type = 'link',
  tooltip: bottonTitle = 'Rimuovi',
}) => {
  if (onConfirm) {
    return (
      <Popconfirm
        title={confirmmessage}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText="Si"
        cancelText="No"
      >
        <Tooltip title={bottonTitle}>
          <DeleteOutlined style={{ color: 'red' }} />
        </Tooltip>
      </Popconfirm>
    );
  }
  return (
    <Tooltip title={bottonTitle}>
      <Button
        icon={<DeleteOutlined style={{ color: 'red' }} />}
        danger={true}
        onClick={onClick}
        type={type}
      >
        {text}
      </Button>
    </Tooltip>
  );
};

export default RemoveButton;
